var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox-container",on:{"click":_vm.toggleSelected}},[_c('div',{staticClass:"checkbox-check",class:_vm.borderColor},[(_vm.isCheck)?_c('div',{staticClass:"check",class:_vm.checkColor}):_vm._e()]),_c('span',{staticClass:"name",class:_vm.checkTextColor},[_c('small',[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }